export default __webpack_public_path__ + "static/image1-f3a10c88ea7925a990ded87f6642d041.png";